export default "__VITE_ASSET__OGIev5Uc__"